const StatisticsActionTypes = {};

StatisticsActionTypes.FETCH_ALL_STATISTICS = 'FETCH_ALL_STATISTICS';
// StatisticsActionTypes.FETCH_STATISTICS = 'FETCH_STATISTICS';
// StatisticsActionTypes.ADD_STATISTICS = 'ADD_STATISTICS';
// StatisticsActionTypes.EDIT_STATISTICS = 'EDIT_STATISTICS';
// StatisticsActionTypes.DELETE_STATISTICS = 'DELETE_STATISTICS';

export default StatisticsActionTypes;
